var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhazeLogoIi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "543.848545px",
    height: "647px",
    viewBox: "0 0 543.848545 647",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PHAZE-P-LOGO-4-Copy-7",
    transform: "translate(-240, -188.0119)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(240, 188.0119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,90.4315341 L339.842485,90.4315341 L339.842485,278.036289 L0,278.036289 L0,647 L204.004047,647 L204.004047,366.836243 L543.848545,366.836243 C543.848545,122.278748 543.848545,0 543.848545,0 C543.848545,0 362.565696,0 0,0 Z",
    id: "Path-12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhazeLogoIi);
export default __webpack_public_path__ + "static/media/phaze-logo-ii.359be4ffad1c115ccacc1a0d89c8beb5.svg";
export { ForwardRef as ReactComponent };